import './Layout.css';

import React, { useContext, useEffect, useState, useRef } from "react";
import { Outlet } from 'react-router-dom';
//import NavMenu from './NavMenu';

export default function Layout() {
    useEffect(() => {
        //const jwt = http.getLocalJwt();
        //if (jwt && jwt != "") {
        //    navigate('/main');
        //}
        document.body.classList.add('bodyBackGround');
        return () => {
            document.body.classList.remove('bodyBackGround');
        }

    }, []);
    return (
        <>
            <div className="container-fluid  vh-100   align-items-center d-flex justify-content-center">
                <Outlet />
            </div>
        </>
    );

}